<template>
  <div id="app">
    <header-nav></header-nav>
    <router-view v-if="isRouterShow"></router-view>
  </div>
</template>

<script>
  import HeaderNav from './components/Header.vue'
  export default {
    name: 'app',
    components: {
      /* HomePage, */
      HeaderNav
    },
    data() {
      return {
        isRouterShow: true,
      }
    },
    reload() {
      this.isRouterShow = false,
        this.$nextTick(function() {
          this.isRouterShow = true
        });
    }
  }
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/App.vue